// AntdNotification.tsx - Global Notification & Toast Provider
import React, { createContext, useContext } from "react";
import { message as antdStaticMessage, App as AntdApp } from "antd";
import toast from "react-hot-toast";

export interface MessageApiContextType {
  success: (content: string) => void;
  error: (content: string) => void;
  info: (content: string) => void;
  warning: (content: string) => void;
  messageApi: any;
}

const MessageContext = createContext<MessageApiContextType | null>(null);

export const notify: MessageApiContextType = {
  success: (content: string) => {
    try {
      antdStaticMessage.success(content);
    } catch (_) {}
  },
  error: (content: string) => {
    try {
      antdStaticMessage.error(content);
    } catch (_) {}
  },
  info: (content: string) => {
    try {
      antdStaticMessage.info(content);
    } catch (_) {}
  },
  warning: (content: string) => {
    try {
      antdStaticMessage.warning(content);
    } catch (_) {}
  },
  messageApi: antdStaticMessage,
};

export const MessageProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  let antdAppMessage: any = null;
  try {
    const appCtx = AntdApp.useApp();
    antdAppMessage = appCtx?.message;
  } catch (_) {
    // Rendered outside AntdApp
  }

  const contextValue: MessageApiContextType = {
    success: (content: string) => {
      try {
        if (antdAppMessage) antdAppMessage.success(content);
        else antdStaticMessage.success(content);
      } catch (_) {
        antdStaticMessage.success(content);
      }
    },
    error: (content: string) => {
      try {
        if (antdAppMessage) antdAppMessage.error(content);
        else antdStaticMessage.error(content);
      } catch (_) {
        antdStaticMessage.error(content);
      }
    },
    info: (content: string) => {
      try {
        if (antdAppMessage) antdAppMessage.info(content);
        else antdStaticMessage.info(content);
      } catch (_) {
        antdStaticMessage.info(content);
      }
    },
    warning: (content: string) => {
      try {
        if (antdAppMessage) antdAppMessage.warning(content);
        else antdStaticMessage.warning(content);
      } catch (_) {
        antdStaticMessage.warning(content);
      }
    },
    messageApi: antdAppMessage || antdStaticMessage,
  };

  return (
    <MessageContext.Provider value={contextValue}>
      {children}
    </MessageContext.Provider>
  );
};

export const useMessageApi = (): MessageApiContextType => {
  const ctx = useContext(MessageContext);
  if (!ctx) {
    return notify;
  }
  return ctx;
};

export default MessageProvider;
